import { render, staticRenderFns } from "./DfAdminList.vue?vue&type=template&id=2a990ab2&"
import script from "./DfAdminList.vue?vue&type=script&lang=js&"
export * from "./DfAdminList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports